import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Article, { Title } from '../components/Article';

const StyledError = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 500px;
  margin: 0 auto 60px auto;
  max-width: ${p => p.theme.globalWidthSmall};
  width: 100%;
`;

const StyledInlineError = styled.div`
  padding: 40px 0;
`;

const ErrorCode = styled.div`
  background-color: #f0f4fa;
  padding: 40px;
  width: 100%;
`;

export function Error({ error }) {
  console.error(error);

  return (
    <StyledError>
      <Article>
        <Title>Beklager! Det oppstod en feil!</Title>

        {process.env.NODE_ENV === 'development' && (
          <ErrorCode>
            <code>{JSON.stringify(error)}</code>
          </ErrorCode>
        )}
      </Article>
    </StyledError>
  );
}

export function InlineError({ error }) {
  console.error(error);

  return (
    <StyledInlineError>
      Beklager! Det oppstod en feil!
      {process.env.NODE_ENV === 'development' && (
        <ErrorCode>
          <code>{JSON.stringify(error)}</code>
        </ErrorCode>
      )}
    </StyledInlineError>
  );
}

Error.propTypes = {
  error: PropTypes.object.isRequired
};

InlineError.propTypes = {
  error: PropTypes.object.isRequired
};
